import { Stack, StackProps, styled } from "@mui/material";

type IBannerInfo = {
  $mandatory?: boolean;
  $isHover?: boolean;
  $isNewLayout?: boolean;
}

export const BannerInfoContainer = styled(Stack)<StackProps & IBannerInfo>(({ theme, $isHover, $isNewLayout }) => ({
  ":hover": {
    background: `rgba(${theme.customColors.backgroundSecondaryHover})`,
    // background: theme.customColors.backgroundSecondaryHover, //TODO ripristinare
    cursor: "pointer"
  },
  alignItems: $isNewLayout ? "center" : undefined,
  background: $isHover ? `rgba(${theme.customColors.backgroundSecondaryHover})` : "transparent",
  // background: $isHover ? theme.customColors.backgroundSecondaryHover : "transparent", //TODO ripristinare
  borderRadius: "0.5rem",
  flexDirection: $isNewLayout ? "row" : undefined,
  justifyContent: $isNewLayout ? "space-between" : undefined,
  margin: "0 0.5rem",
  paddingRight: $isNewLayout ? "0.5rem" : undefined,
  width: "100%"
}));

export const TypoContainer = styled(Stack)<StackProps & Pick<IBannerInfo, "$isNewLayout">>(({ $isNewLayout }) => ({
  alignItems: $isNewLayout ? "flex-start" : "center",
  background: "transparent",
  display: "flex",
  flexDirection: $isNewLayout ? "column" : "row",
  flexGrow: 1,
  gap: $isNewLayout ? "0.25rem" : undefined,
  justifyContent: "space-between"
}));

export const BannerInfo = styled(Stack)<StackProps & IBannerInfo>(({ theme, $mandatory, $isNewLayout }) => ({
  "&:before": {
    alignSelf: "stretch",
    background: $mandatory ? theme.customColors.textWarning : theme.customColors.systemSecondary01,
    borderRadius: "0.125rem",
    content: "''",
    marginLeft: "0.5rem",
    marginRight: "1rem",
    position: "relative",
    width: "0.125rem"
  },
  display: "flex",
  flex: $isNewLayout ? 1 : undefined,
  flexDirection: "row",
  padding: "0.5rem 0.5rem 0.5rem 0rem"
}));
